<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div [formGroup]="formGroupToShow" class="form-control--{{ inputToShow.key }}">
    @switch (inputToShow.controlType) {
        @case (inputTypesEnum.TEXTBOX) {
            <div>
                @if (!inputToShow.hideInput) {
                    <div>
                        <input
                                [formControlName]="inputToShow.key"
                                [id]="inputId"
                                [maxLength]="inputToShow['maxLength']"
                                [max]="inputToShow['max']"
                                [minLength]="inputToShow['minLength']"
                                [min]="inputToShow['min']"
                                [ngClass]="inputToShow.inputClass"
                                [required]="inputToShow.required"
                                [step]="inputToShow['step']"
                                [type]="inputToShow['type']"
                                class="form-control"
                        />
                    </div>
                } @else {
                    <span>{{ inputToShow.value }}</span>
                }
                <ng-container *ngTemplateOutlet="inputError"></ng-container>
            </div>
        }
        @case (inputTypesEnum.DROPDOWN) {
            <div>
                @if (!inputToShow.hideInput) {
                    <select
                            [formControlName]="inputToShow.key"
                            [id]="inputId"
                            [ngClass]="inputToShow.inputClass"
                            [required]="inputToShow.required"
                            class="form-control"
                    >
                        @for (opt of inputToShow.options; track opt) {
                            <option
                                    [ngValue]="
                                    inputToShow['simpleArr'] ? opt : inputToShow['valueKey'] ? opt[inputToShow['valueKey']] : opt.key
                                "
                            >
                                {{
                                    (inputToShow['simpleArr'] ? opt : inputToShow['showKey'] ? opt[inputToShow['showKey']] : opt.value)
                                        | translate
                                }}
                            </option>
                        }
                    </select>
                } @else {
                    <span>{{ showValue }}</span>
                }
                <ng-container *ngTemplateOutlet="inputError"></ng-container>
            </div>
        }
        @case (inputTypesEnum.CHECKBOX) {
            <div>
                @if (!inputToShow.hideInput) {
                    <span class="form-check-label pl-4">
                        <input
                                [formControlName]="inputToShow.key"
                                [id]="inputId"
                                [ngClass]="inputToShow.inputClass"
                                class="form-check-input"
                                type="checkbox"
                        />
                        {{ inputToShow['checkboxLabel'] }}
                    </span>
                } @else {
                    @if (inputToShow.disabled) {
                        <span>{{ inputToShow['isChecked'] ? 'Enable' : 'Disable' }}</span>
                    }
                    @if (!inputToShow.disabled) {
                        <span>{{ inputToShow['displayValue'] }}</span>
                    }
                }
                <ng-container *ngTemplateOutlet="inputError"></ng-container>
            </div>
        }
    }
</div>

<ng-template #inputError>
    @if (inputControl.invalid && showValidationMessage && !inputToShow.hideInput) {
        <ul class="text-danger list-unstyled m-0">
            @for (errorMsg of getValidationErrors(inputControl.errors, inputToShow); track errorMsg) {
                <li>
                    <small>{{ errorMsg.query | translate: errorMsg.args }}</small>
                </li>
            }
        </ul>
    }
</ng-template>
